import React, { useContext, useEffect, useState } from "react"
import { useLocation } from "@reach/router"
import { WingsButton, WingsIcon } from "@wingspans-ui"
import Link, { navigate } from "../../link"
import WingsLogoFull from "../../../static/assets/images/Wingspans-new-logo.svg"
import { FormattedMessage, useIntl } from "react-intl"
import BookDemoButton from "../home-page/BookDemoButton"
import useIsMainSite from "../hooks/useIsMainSite"
import { FirebaseContext } from "../Firebase/index"
import { isHeaderVisible } from "../layout/header-footer-visibility"
import PublicHeaderNav from "./PublicHeaderNav"
import PublicHeaderMobileMenu from "./PublicHeaderMobileMenu"
import "../../global-styles/home-style-overrides.css"
import "./header.css"

/**
 * Header for logged out users. Hidden on the paths listed in
 * header-footer-visibility.js. Logged-in members see WingsAppNav instead, which
 * hides #site-navbar via CSS. If on a subdomain, displays a Sign In button to
 * navigate to login page. Otherwise, displays a Book a Demo button.
 * @returns {JSX}
 */
const PublicHeader = () => {
  const location = useLocation()
  const showBookDemo = useIsMainSite()
  const { profile, prospectivePreviewCode } = useContext(FirebaseContext)
  const { formatMessage } = useIntl()
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)

  const isProspectiveStudent = !!(prospectivePreviewCode || (!!profile && profile.prospectiveSchoolCode))

  // close the mobile menu after any navigation
  useEffect(() => {
    setIsMobileMenuOpen(false)
  }, [location?.pathname])

  if (!isHeaderVisible(location?.pathname, { isProspectiveStudent })) {
    return null
  }

  return (
    <header
      id="site-navbar"
      className={`public-header printer-none w-flex w-flex-row w-items-center w-justify-between${showBookDemo ? " public-header--with-nav" : ""}`}
    >
      {showBookDemo && (
        <button
          type="button"
          className="public-header-hamburger"
          aria-label={formatMessage({ id: "public-header-menu-toggle", defaultMessage: "Toggle navigation menu" })}
          aria-expanded={isMobileMenuOpen}
          aria-controls="public-header-mobile-menu"
          onClick={() => setIsMobileMenuOpen((open) => !open)}
        >
          <WingsIcon icon={isMobileMenuOpen ? "close" : "menu"} size="small" />
        </button>
      )}
      <div className="public-header-logo-container w-flex w-items-center w-justify-center">
        <Link to="/" className="public-header-logo-link w-flex w-items-center" data-gtm="header-logo">
          <img src={WingsLogoFull} alt="Wingspans" className="public-header-logo" />
        </Link>
      </div>
      {showBookDemo && <PublicHeaderNav />}
      <div className="public-header-right w-flex w-items-center w-justify-center">
        {showBookDemo ? (
          <BookDemoButton variant="on-dark" size="tiny" section="header" />
        ) : (
          <WingsButton variant="on-dark" size="tiny" onClick={() => navigate("/login")} >
            <FormattedMessage id="account-menu-sign-in" defaultMessage="Sign In" />
          </WingsButton>
        )}
      </div>
      {showBookDemo && (
        <PublicHeaderMobileMenu isOpen={isMobileMenuOpen} onNavigate={() => setIsMobileMenuOpen(false)} />
      )}
    </header>
  )
}

export default PublicHeader
